import {skeletonGet} from './skeleton/skeletonGet';
import {skeletonPost} from "./skeleton/skeletonPost";
import {DeleteAlertMarketPayload, UserMonitorPayload} from "../@types/actions";
import {skeletonDelete} from "./skeleton/skeletonDelete";

const liveEndpoint = 'lv'

export const GetLiveAlertsCall = (): Promise<any> => {
    return skeletonGet('event', liveEndpoint);
};

export const DeleteLiveAlertCall = (payload: DeleteAlertMarketPayload): Promise<any> => {
    const marketId = `${payload.marketId}${payload.sbv && payload.sbv !== '#' ? '@' + payload.sbv : ''}`
    return skeletonDelete(`event/${payload.eventId}/${payload.bookmakerId}/${marketId}`, liveEndpoint);
};

export const GetSettingsCall = (template: string = 'default'): Promise<any> => {
    return skeletonGet(`template/${template}`, liveEndpoint);
};

export const StoreSettingCall = (payload: UserMonitorPayload): Promise<any> => {
    return skeletonPost(payload, `template/${payload.name}`, liveEndpoint);
};

export const DeleteSettingCall = (template: string): Promise<any> => {
    return skeletonDelete(`template/${template}`, liveEndpoint);
};

export const GetLiveEventCall = ({eventId}: { eventId: number }): Promise<any> => {
    return skeletonGet(`event/${eventId}`, liveEndpoint);
};

export const GetLiveSpreadsCall = (eventId: number, bookmakerId: number, marketId: string): Promise<any> => {
    return skeletonGet(`event/${eventId}/bookmaker/${bookmakerId}/market/${marketId}`, liveEndpoint);
};